/**
 * Maps address fields from ReturningPatientOutput into intake responses.
 *
 * Used on the returningPatient arc's onDone transitions so the PCP search
 * component (which reads ZIP from responses) gets the correct value.
 */

import { assign } from "xstate";
import type { ReturningPatientOutput } from "../contracts/arc-contracts";
import { mapAddressToResponses } from "../helper/address-response-mapper";

export const mapReturningPatientAddress = assign(
  // biome-ignore lint/suspicious/noExplicitAny: XState cross-arc event typing
  ({ context, event }: { context: any; event: any }) => {
    const output = event.output as ReturningPatientOutput;
    return {
      responses: mapAddressToResponses(
        context.intakeFormSections,
        context.responses ?? {},
        {
          street: output.address,
          city: output.city,
          state: output.state,
          zip: output.zip,
          line2: output.addressLine2,
        },
      ),
    };
  },
);
